import React from 'react'
import { observer } from 'mobx-react-lite'
import { runInAction } from 'mobx'
import { useParams } from 'react-router-dom';
import axiosService from '../../../../../../utils/AxiosService';
import { toastError } from '../../../../../FormComponents/Toasts';
import CampaignInfluencerComment from './CampaignInfluencerComment';
import CampaignInfluencerCommentsPanel from '../../../../../Shared/CampaignInfluencerSidebar/CampaignInfluencerCommentsPanel';


export default observer(function CampaignComments({ auth, isClientThread }) {
  const { id, campaign_authentication_id } = useParams()

  const handleAddComment = ({ message }, { resetForm }) => {
    axiosService.post(`/api/project_manager/campaigns/${id}/campaign_authentications/${campaign_authentication_id}/campaign_authentication${isClientThread ? '_client' : ''}_comments`, { campaign_authentication_comment: { message } })
      .then((resp) => {
        runInAction(() => {
          if (isClientThread) {
            auth.client_comments.push(resp)
          } else {
            auth.comments.push(resp)
          }
        })
        resetForm();
      })
      .catch(err => toastError(err))
  }

  return (
    <CampaignInfluencerCommentsPanel
      auth={auth}
      isClientThread={isClientThread}
      onSubmitComment={handleAddComment}
      CommentComponent={CampaignInfluencerComment}
      helperText='Only PMs can see this thread'
    />
  )
})

